<template>
  <section class="app-transporte">
    <v-container grid-list-xl style="max-width: 600px">
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12>
          <section class="d-flex justify-center">
            <img width="130" src="@/assets/vai-vem/vaivem-icon.svg" />
          </section>
          <v-card outlined class="app-card">
            <v-card-title class="justify-center app-card-title">VaiVem</v-card-title>
            <v-card-text class="app-card-content">
              <v-form ref="form" lazy-validation>
                <v-row class="justify-center">
                  <v-radio-group v-model="form.option" :rules="[rules.required]">
                    <v-radio label="Estudante" value="estudante"></v-radio>
                    <v-radio label="Trabalhador" value="trabalhador"></v-radio>
                  </v-radio-group>
                </v-row>
                <v-row>
                  <v-col :md="12" :sm="12" :xs="12" cols="12">
                    <v-text-field
                      v-model="form.cpf"
                      placeholder="Digite o CPF"
                      v-mask="'###.###.###-##'"
                      label="CPF *"
                      :rules="[rules.required, rules.cpf]"
                      filled
                      rounded
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col :md="12" :sm="12" :xs="12" cols="12">
                    <v-text-field
                      v-model="form.dataNascimento"
                      placeholder="Data de Nascimento"
                      type="date"
                      label="Data de Nascimento *"
                      :rules="[rules.required, rules.validateData]"
                      filled
                      rounded
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-row no-gutters>
                    <v-col cols="12" class="d-flex justify-center">
                      <v-input
                        v-model="form.recaptcha"
                        :rules="[rules.required]"
                        hide-details="auto"
                        class="recaptcha-input"
                      >
                        <template #default>
                          <div class="recaptcha-wrapper">
                            <vue-recaptcha
                              ref="recaptcha"
                              :sitekey="siteKey"
                              :loadRecaptchaScript="true"
                              @verify="verifyRecaptcha"
                              @expired="expiredRecaptcha"
                            />
                          </div>
                        </template>
                      </v-input>
                    </v-col>
                  </v-row>
                </v-row>
                <v-row class="justify-end mr-2">
                  <v-col :md="3" :sm="3" :xs="12" cols="6">
                    <v-btn
                      @click="limpar"
                      depressed
                      block
                      large
                      style="color: #1976d2; background-color: #d5e9ef"
                      >Limpar</v-btn
                    >
                  </v-col>
                  <v-col :md="3" :sm="3" :xs="12" cols="6">
                    <v-btn depressed block large color="primary" @click="onSubmit">Continuar</v-btn>
                  </v-col>
                </v-row>
              </v-form>
              <div class="loading" v-if="isLoading">
                <v-progress-circular :size="25" color="primary" indeterminate></v-progress-circular>
              </div>
            </v-card-text>
          </v-card>
          <br />
          <ModalResultadoEstudante
            :dataAluno="resultadoEstudante"
            :dialog.sync="dialogResultadoEstudante"
            @closeDialog="dialogResultadoEstudante = false"
          />
        </v-flex>
      </v-layout>
      <DialogErrorDesempregado
        :alertErrorDesempregado="alertErrorDesempregado"
        :onClose="() => (alertErrorDesempregado = false)"
      />
      <DialogAlertDesempregado
        :alertDesempregado="alertDesempregado"
        :onClose="() => (alertDesempregado = false)"
      />
      <v-dialog v-model="alert" width="500">
        <template>
          <v-card>
            <v-toolbar dark color="primary"> Informações </v-toolbar>
            <v-card-text class="mt-5 p-0">
              <div class="text flex-column justify-center mt-3">
                <p class="text-center">
                  <v-icon x-large color="orange darken-2 " aria-hidden="true"
                    >fa fa-exclamation-triangle fa-4x</v-icon
                  >
                </p>
                <p class="text-center">
                  <strong>O seu CPF não foi encontrado em nossa base de dados</strong>
                </p>
                <p class="text-justify mb-0">
                  O VAIVEM, nesta fase inicial, está contemplando os estudantes que possuem a
                  Carteira de Estudante da Macrorregião.
                </p>
                <p class="text-justify mb-0">
                  Se você já possui a Carteira de Estudante da Macrorregião, e mesmo assim seu CPF
                  não foi encontrado, entre em contato com a Arce pelo telefone 0800 216 3766 para
                  regularizar seu cadastro.
                </p>
                <p class="text-justify mb-0">
                  Se você não possui a Carteira de Estudante da Macrorregião procure sua entidade
                  estudantil para solicitar a sua carteira e posteriormente fazer o cadastro junto a
                  Arce.
                </p>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="closeAlert()"> Ok </v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-container>
    <modalResultado
      :resultado="resultado"
      :dialog="dialogResultado"
      :onClose="
        () => {
          dialogResultado = false;
        }
      "
    />
  </section>
</template>

<script>
import { mask } from 'vue-the-mask';
import VueRecaptcha from 'vue-recaptcha';
import { VUE_APP_RECAPTCHA_KEY } from '@/commons/config';
import vaiVemService from '@/services/vai-vem.service';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import dayjs from 'dayjs';
import ModalResultado from '@/views/transportes/vai-vem/aluno/modalResultado.vue';
import FunctionsCommuns from '@/util/FunctionsCommuns';
import DialogErrorDesempregado from '@/views/transportes/vai-vem/components/DialogErrorDesempregado.vue';
import DialogAlertDesempregado from '@/views/transportes/vai-vem/components/DialogAlertDesempregado.vue';
import ModalResultadoEstudante from './ModalResultadoEstudante.vue';
import { validateCpf } from '@/helpers/cpf.validator';

dayjs.extend(customParseFormat).locale('pt-BR');

export default {
  metaInfo: {
    title: 'VaiVem',
  },
  components: {
    DialogAlertDesempregado,
    DialogErrorDesempregado,
    ModalResultado,
    VueRecaptcha,
    ModalResultadoEstudante,
  },
  directives: {
    mask,
  },
  data: () => ({
    siteKey: VUE_APP_RECAPTCHA_KEY,
    isLoading: false,
    form: {
      cpf: null,
      dataNascimento: null,
      recaptcha: null,
      option: null,
    },
    rules: {
      required: value => (!!value && value !== undefined) || 'Esse campo deve ser preenchido',
      cpf: value => !!validateCpf(value) || 'CPF inválido',
      validateData: value =>
        FunctionsCommuns.isValidDate(FunctionsCommuns.formatBRDate(value)) || 'Data invalida',
    },
    alert: false,
    msg: '',
    dialogResultado: false,
    resultado: null,
    alertErrorDesempregado: false,
    message: { title: null, text: null },
    alertDesempregado: false,
    dialogResultadoEstudante: false,
    resultadoEstudante: null,
  }),
  methods: {
    verifyRecaptcha(value) {
      this.form.recaptcha = value;
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.form.recaptcha = null;
    },
    onSubmit() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        this.isLoading = true;
        const { cpf, dataNascimento } = this.form;
        if (this.form.option === 'trabalhador') {
          vaiVemService.loginDetran().subscribe({
            next: () => {
              vaiVemService
                .findByDesempregado([cpf], FunctionsCommuns.formatBRDate(dataNascimento))
                .subscribe(
                  res => {
                    const { data } = res;
                    if (data['situacao'] === 'disponivel_para_retirada') {
                      this.dialogResultado = true;
                      this.resultado = data;
                      this.expiredRecaptcha();
                    } else {
                      this.alertDesempregado = true;
                    }
                    this.isLoading = false;
                  },
                  err => {
                    this.alertErrorDesempregado = true;
                    this.isLoading = false;
                  }
                );
            },
            error: error => {
              this.isLoading = false;
            },
          });
        } else {
          vaiVemService.findByStudant(cpf, dataNascimento).subscribe(
            res => {
              this.dialogResultadoEstudante = true;
              this.resultadoEstudante = res;
              this.isLoading = false;
              this.alert = false;
              this.expiredRecaptcha();
            },
            err => {
              this.isLoading = false;
              this.expiredRecaptcha();
              if (err?.response?.status == 404) {
                this.alert = true;
                this.msg = err.response.data;
              }
            }
          );
        }
      }
    },
    closeAlert() {
      this.alert = false;
    },
    limpar() {
      this.$refs.form.reset();
      this.$refs.recaptcha.reset();
    },
  },
};
</script>

<style lang="scss" scoped>
.loading {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  text-align: center;
  .v-progress-circular {
    margin: auto;
  }
}

/* ajustes de centralização do recaptcha */
.recaptcha-input {
  display: inline-block !important;
  width: auto !important;
  max-width: 340px;
}

.recaptcha-input ::v-deep(.v-input__slot) {
  padding: 0 !important;
}

.recaptcha-input ::v-deep(.v-input__control) {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.recaptcha-wrapper {
  display: inline-block;
  margin: 0 auto;
  text-align: center;
}

.recaptcha-wrapper ::v-deep(.g-recaptcha) {
  display: block !important;
  margin: 0 auto !important;
}
</style>
